<template>
  <print-preview @reset="reset" :landscape="landscape">
    <div slot="pages">
      <page
        :styles="styles"
        :default-banner="false"
        class="print-customer-form"
      >
        <template slot="banner">
          <div class="flexRow px-4" style="width: 100%">
            <div
              class="di-flex justify-start"
              style="flex: 1; align-items: center; font-size: 14px"
            >
              <img :src="branch_logo" alt="SO" class="print_logo" />
            </div>

            <div class="di-flex align-center">
              <div class="text-xs-center align-end px-4 font-weight-bold">
                <h4>{{ branch_fa_name }}</h4>
                <h4>{{ LONG_APP_NAME }}</h4>
                <h4>{{ $t("ccif") }}</h4>
              </div>
            </div>
            <div class="flex-column align-end" style="flex: 1; font-size: 12px">
              <span>
                <span class="pcf-label">{{ $t("reg_no") }}: </span>
                <span class="pcf-text">{{ customer.id }}</span>
              </span>
              <span>
                <span class="pcf-label">{{ $t("reg_date") }}: </span>
                <span class="pcf-text">{{ customer.created_at }}</span>
              </span>
              <span>
                <span class="pcf-label">{{ $t("persian_date") }}: </span>
                <span class="pcf-text">{{
                  customer.created_at | persianDateFilter(true)
                }}</span>
              </span>
            </div>
          </div>
        </template>

        <template slot="header">
          <th colspan="100%" class="justify-end py-2">
            <!-- <v-divider></v-divider> -->
          </th>
        </template>

        <template slot="body">
          <tr>
            <td
              colspan="100%"
              class="lr--text px-3 body-2 secondary white--text"
            >
              <span class="pcf-label">
                {{ $t("corporate_details") }}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("corporate_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.corporate_name
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("nature_of_business") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.nature_of_business
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("tin_number") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.tin_number
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("customer_type") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.customer_type
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("incorporation_date") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.incorporation_date
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("license_no") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.license_no
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("license_issue_date") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.license_issue_date
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("license_expire_date") }}: </span>
              <span class="mx-2 pcf-text">{{
                $t(customer.corporate.license_expire_date)
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("transactions_count") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.transactions_count
              }}</span>
            </td>

            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("transactions_amount") }}: </span>
              <span class="mx-2 pcf-text">{{
                $t(customer.corporate.transactions_amount)
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("monthly_income") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.monthly_income
              }}</span>
            </td>

            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("monthly_turnover") }}: </span>
              <span class="mx-2 pcf-text">{{
                $t(customer.corporate.monthly_turnover)
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("phones") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.pretty_company_phones
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("email") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.company_email
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("status") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.temporary ? $t("temporary") : $t("permanent")
              }}</span>
              <span
                class="mx-2 pcf-text"
                v-if="customer.corporate.sanction_screening"
                >({{ $t("sanction_screening") }})</span
              >
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("risk_profile") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.risk_profile
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("source_of_fund") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.source_of_fund
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("business_address") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.business_address
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("reg_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.reg_name
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("reg_address") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.reg_address
              }}</span>
            </td>
          </tr>

          <tr>
            <td colspan="100%" class="white py-2"></td>
          </tr>
          <tr class="mt-2">
            <td
              colspan="100%"
              class="lr--text px-3 body-2 secondary white--text"
            >
              <span class="pcf-label">
                {{ $t("contact_person_details") }}
              </span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("contact_person_name") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.contact_name
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("designation") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.contact_designation
              }}</span>
            </td>
          </tr>
          <tr>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("phones") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.pretty_contact_phones
              }}</span>
            </td>
            <td colspan="50%" class="lr--text px-3">
              <span class="pcf-label">{{ $t("email") }}: </span>
              <span class="mx-2 pcf-text">{{
                customer.corporate.contact_email
              }}</span>
            </td>
          </tr>

          <template v-for="(director, i) in customer.directors">
            <tr :key="`d${i}`">
              <td colspan="100%" class="white py-2"></td>
            </tr>
            <tr class="mt-2" :key="`c${i}`">
              <td colspan="100%" class="lr--text body-2 secondary white--text">
                <span class="pcf-label px-3">
                  {{ director.designation }}
                </span>
              </td>
            </tr>
            <tr :key="i">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("name") }}: </span>
                <span class="mx-2 pcf-text">{{ director.name }}</span>
              </td>
              <td colspan="30%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("father_name") }}: </span>
                <span class="mx-2 pcf-text">{{ director.father_name }}</span>
              </td>
              <td
                rowspan="5"
                colspan="20%"
                class="customer-image"
                style="text-align: center; vertical-align: middle"
              >
                <img :src="director.image" alt="Image" />
              </td>
            </tr>
            <tr :key="`r4${i}`">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("designation") }}: </span>
                <span class="mx-2 pcf-text"
                  >{{ director.designation }} (
                  {{ director.share_percentage }} % )</span
                >
              </td>
              <td colspan="30%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("monthly_income") }}: </span>
                <span class="mx-2 pcf-text">{{ director.monthly_income }}</span>
              </td>
            </tr>
            <tr :key="`r${i}`">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("tazkira_no_or_p") }}: </span>
                <span class="mx-2 pcf-text">{{ director.tazkira_no }}</span>
              </td>
              <td colspan="30%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("nationality") }}: </span>
                <span class="mx-2 pcf-text">{{ director.nationality }}</span>
              </td>
            </tr>
            <tr :key="`r45${i}`">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("issue_date") }}: </span>
                <span class="mx-2 pcf-text">{{ director.issue_date }}</span>
              </td>
              <td colspan="30%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("expire_date") }}: </span>
                <span class="mx-2 pcf-text">{{ director.expire_date }}</span>
              </td>
            </tr>
            <tr :key="`r24${i}`">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("gender") }}: </span>
                <span class="mx-2 pcf-text">{{ director.gender }}</span>
              </td>
              <td colspan="30%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("marital_status") }}: </span>
                <span class="mx-2 pcf-text">{{ director.marital_status }}</span>
              </td>
            </tr>
            <tr :key="`r2${i}`">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("place_of_birth") }}: </span>
                <span class="mx-2 pcf-text">{{ director.place_of_birth }}</span>
              </td>
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("date_of_birth") }}: </span>
                <span class="mx-2 pcf-text">{{ director.date_of_birth }}</span>
              </td>
            </tr>
            <tr :key="`r3${i}`">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("current_address") }}: </span>
                <span class="mx-2 pcf-text">{{
                  director.current_address
                }}</span>
              </td>
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("permanent_address") }}: </span>
                <span class="mx-2 pcf-text">{{
                  director.permanent_address
                }}</span>
              </td>
            </tr>
            <tr :key="`r4ll${i}`">
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("phones") }}: </span>
                <span class="mx-2 pcf-text">{{ director.pretty_phones }}</span>
              </td>
              <td colspan="50%" class="lr--text px-3">
                <span class="pcf-label">{{ $t("email") }}: </span>
                <span class="mx-2 pcf-text">{{ director.email }}</span>
              </td>
            </tr>
          </template>
          <!-- <tr>
            <td colspan="100%" class="white pt-3 pb-2 text-xs-left" dir="ltr">
              <p>
                <strong>Undertaking: </strong><br />
                I/we hereby requested {{ LONG_APP_NAME }} to register us
                mentioned above on the basis of the information provided by
                me/us herein. Which I/we confirm is true and correct in all
                aspect. The Registration in {{ LONG_APP_NAME }} will be used for
                bonafide transactions relating to me/our business. I/we agree to
                inform you of any change in the information provided in this
                form with related document. I/we also undertake to abide by the
                requirements of the prevention of money laundering act/Policy in
                force.
                <br />
              </p>
              <hr />
            </td>
          </tr> -->
          <!-- <tr dir="rtl">
            <td colspan="100%" class="white pt-3 pb-2 text-xs-right">
              <p>
                <strong>ژمنه: </strong><br />
                زه/موږ {{ branch_ps_name }} څخه هیله کوو چی د هغه معلوماتو پر
                بنست چه ما/موږ پورته ذکر کری چی زه/موږ یی تائیدوم/ تائید، راته
                راجسټر کړيٕر. همدارنکه ژمنه کوم/کوو چی دخپل/اخپلو
                {{ branch_ps_name }} راجستر څخه به په خپلو قانونی او سوداګریزی و
                معلوماتو کی کار اخلم/اخلو او په پورته ذکر شوی معلوماتو کی کار
                اخلم/اخلو او که پورته ژمنه کوم/کوو چی دپیسو د پر یمنځلو څخه
                دمخننوي قانون او مقررات به په نظر کی نیسم/نیسو.
                <br />
              </p>
              <hr />
            </td>
          </tr> -->
          <tr dir="rtl">
            <td colspan="100%" class="white pt-3 pb-2 text-xs-right">
              <p>
                <strong>تعهدنامه: </strong><br />
                بدین وسیله از {{ branch_fa_name }} در خواست مینمایم/مینماییم تا
                به اساس معلومات ارایه شده که از آن اطمینان کامل میدهم/میدهیم که
                من/ما را ثبت نام نمایند. ثبت نام در {{ branch_fa_name }} با حسن
                نیت برای پیشبرد معاملات /تجارتی من/ما استفاده خواهد شد همچنان
                تعهد می سپارم/ می سپاریم که از ثبت نام در
                {{ branch_fa_name }} را برای معاملات قانونی و تجاری خویش استفاده
                نمایم/ نماییم و در صورت هرنوع تغیر و تبدیلی در معلومات ارایه شده
                فوق به خدامات پولی را مطلع سازم/سازیم تعهد مینمایم/مینماییم که
                مقررات و پالیسی نافذه قانون تطهیر پولی را در نظر گیرم/گیریم.
              </p>
              <!-- <hr /> -->
            </td>
          </tr>
          <tr>
            <td class="pt-3 pb-3 white" colspan="100%">
              <div class="di-flex justify-space-around font-weight-bold">
                <div>President Sign</div>
                <div>Voice President Sign</div>
                <div>Authrozied Sign</div>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="100%" class="white pt-3 pb-2 lr--text">
              <p>
                <strong>{{ $t("kyc_notes") }} : </strong><br />
                {{ customer.corporate.kyc_notes }}
              </p>
            </td>
          </tr>
          <tr>
            <td colspan="100%" class="rlr-border pt-2"></td>
          </tr>
          <tr>
            <td class="pt-1 pb-3" colspan="50%">
              <strong>CIF Processed By </strong>
            </td>
            <td class="pt-2 pb-3" colspan="30%">
              <strong>Date <br />{{ customer.created_at }}</strong>
            </td>
            <td class="pt-2 pb-3" colspan="20%">
              <strong>Sign</strong>
            </td>
          </tr>

          <tr>
            <td colspan="100%" class="rlr-border pt-1"></td>
          </tr>
          <tr>
            <td class="pt-2 pb-3" colspan="50%">
              <strong>CIF Verified By </strong>
            </td>
            <td class="pt-2 pb-3" colspan="30%">
              <strong>Date <br />{{ customer.created_at }}</strong>
            </td>
            <td class="pt-2 pb-3" colspan="20%">
              <strong>Sign</strong>
            </td>
          </tr>

          <tr>
            <td colspan="100%" class="rlr-border pt-1"></td>
          </tr>
          <tr>
            <td class="pt-2 pb-3 flex align-content-end" colspan="50%">
              <strong>Compliance Verification By </strong>
            </td>
            <td class="pt-2 pb-3" colspan="30%">
              <strong>Date <br /></strong>
            </td>
            <td class="pt-2 pb-4" colspan="20%">
              <strong>Sign</strong>
            </td>
          </tr>
        </template>
      </page>
    </div>
  </print-preview>
</template>

<script>
import get from "lodash/get";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    loading: false,
    customer: {
      type: "customer",
      is_bank: false,
      corporate: {
        first_name: "",
        middle_name: "",
        last_name: "",
        father_name: "",
        date_of_birth: new Date().toLocaleDateString("en-ca"),
        place_of_birth: "",
        gender: "Male",
        marital_status: "Single",
        current_address: "",
        permanent_address: "",
        resident: "resident",
        doctype: "passport",
        nationality: "",
        tazkira_no: "",
        passport_no: "",
        issuer_place: "",
        issue_date: "",
        expire_date: "",
        phones: [],
        email: "",
        nature_of_business: "",
        source_of_income: "",
        monthly_income: "",
        monthly_turnover: "",
        tin_number: "",
        tenure: "",
        risk_profile: "",
        kyc_notes: "",
        kyc_updated_date: new Date().toLocaleDateString("en-ca"),
        next_kyc_date: "",
        current_designation: "",
        current_employer: "",
        employer_description: "",
      },
    },
  }),
  computed: {
    items() {
      return this.dailyReport.items;
    },

    landscape() {
      return false;
    },

    styles() {
      if (this.landscape) return { "min-height": "200mm", width: "290mm" };
      return { "min-height": "280mm", width: "200mm" };
    },
  },
  created() {
    let id = this.$store.state.route.params.id;
    if (id) {
      this.axios
        .get(`customers/${id}?type=corporate`)
        .then((response) => {
          this.customer = response.data.data;
          this.correct_route = true;
          this.loading = false;
        })
        .catch((error) => {
          this.correct_route = false;
          this.loading = false;
        });
    }
  },
  methods: {
    reset() {
      this.$router.go(-1);
    },
  },
};
</script>